import script from "./create.group.modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./create.group.modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__